import backend, {LOOM_API} from 'utils/backend/loom/api_library';

import queryString from 'query-string';

import {
  adaptLoomCaregiverDetail,
  adaptLoomCaregiverList,
  toLoomCaregiverListQuery,
} from './caregiver_adapter';
import {adaptLoomCommunications, adaptLoomWorkflows} from 'utils/backend/loom/loom_lead/workflow_adapter';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom caregiver reads can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const queryCaregiver = async (filters, sort, cursor, options = {}) => {
  const query = queryString.stringify(
      toLoomCaregiverListQuery(filters, sort, cursor, options),
      {skipNull: true, skipEmptyString: true},
  );
  const response = await backend.get(`${loomApi()}/api/careos/caregivers?${query}`);
  return adaptLoomCaregiverList(response);
};

// These reads take Loom's caregiver id. The detail route also takes a legacy RN, for old links.
const caregiverPath = (caregiverId) => `${loomApi()}/api/careos/caregivers/${encodeURIComponent(caregiverId)}`;

const getCaregiver = async (caregiverId) => {
  const response = await backend.get(caregiverPath(caregiverId));
  return adaptLoomCaregiverDetail(response);
};

const listWorkflows = async (caregiverId) => {
  const response = await backend.get(`${caregiverPath(caregiverId)}/workflows`);
  return adaptLoomWorkflows(response);
};

const listInvitations = async (caregiverId) => {
  const response = await backend.get(`${caregiverPath(caregiverId)}/invitations`);
  return response?.invitations || [];
};

const listCommunications = async (caregiverId) => {
  const response = await backend.get(`${caregiverPath(caregiverId)}/communications`);
  return adaptLoomCommunications(response);
};

const cancelInvitation = (invitationId) => {
  return backend.post(`${loomApi()}/api/careos/invitations/${encodeURIComponent(invitationId)}/cancel`);
};

export default {
  getCaregiver,
  queryCaregiver,
  listWorkflows,
  listInvitations,
  listCommunications,
  cancelInvitation,
};
